import React from "react";
import styled from "styled-components";

const HeaderBar = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 12px 40px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 12px;
`;

const Title = styled.div`
  margin-right: 60px;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  font-weight: 500;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #fafafa;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 4px 8px;

  input {
    border: none;
    outline: none;
    font-size: 14px;
    background: transparent;
    margin-left: 4px;
  }
`;

const CadastroCursosHeader = () => (
  <HeaderBar>
    <TitleGroup>
      <Title>
        CADASTRO DE CURSOS
      </Title>
    </TitleGroup>
    <SearchBox>
      <span
        className="material-symbols-outlined"
        style={{ fontSize: 18, color: "gray" }}
      >
        search
      </span>
      <input placeholder="Pesquisar por nome" />
    </SearchBox>
  </HeaderBar>
);

export default CadastroCursosHeader;